<template>
  <div>
    <HomeHero />

    <div class="page-content">
      <ExcellencePath />
      <ElitePrograms />
      <ProgramOverview />
      <Testimonials />
    </div>
    
    <SiteFooter />
  </div>
</template>
  
<script>
  import ExcellencePath from '../components/HomePage/ExcellencePath.vue';
  import ElitePrograms from '../components/HomePage/ElitePrograms.vue';
  import HomeHero from '../components/Hero/HomeHero.vue';
  import ProgramOverview from '../components/HomePage/ProgramOverview.vue';
  import SiteFooter from '../components/Footer/SiteFooter.vue';
  import Testimonials from '../components/HomePage/Testimonials.vue';

  export default {
    name: 'LandingPage',
    components: {
      ExcellencePath,
      ElitePrograms,
      HomeHero,
      ProgramOverview,
      SiteFooter,
      Testimonials,
    },
  };
</script>